<template lang="pug">
  .component-client-list-form.filter-form
    .row
      .columns.shrink
        a.fa.fa-search.fa-2x(@click="advanced = !advanced")
      .basic.row(v-if="!advanced")
        .columns
          select(v-model="search.status")
            option(:value="null", disabled, selected) Status
            option ACTIVE
            option SUSPENDED
            option CANCELED
            option ON HOLD
        .columns
          SelectizeClientType(@optionSelected="setClientType", @optionRemoved="search.client_type = null")
        .columns
          RangePicker(@input="setRange")
      .advanced(v-if="advanced")
        .columns
          input-form(:fields="['query','balance']", :placeholders="['Client search', 'Balance filter']", @updatedData="setSearch")
      .columns.text-right(v-if="!advanced")
        a.fa.fa-filter.fa-2x(@click="setFilters")
</template>

<script>
import InputForm from './InputForm'
import DatePicker from '../../DatePicker'
import SelectizeClientType from '../lists/selectize/SelectizeClientType'
import RangePicker from '../../RangePicker'

export default {
  name: 'ClientListForm',
  components: {RangePicker, SelectizeClientType, DatePicker, InputForm},
  data() {
    return {
      advanced: false,
      search: {
        client_type: null,
        created_from: null,
        created_to: null,
        query: null,
        balance: null,
        status: null,
      }
    }
  },
  methods: {
    setRange(range) {
      this.search.created_from = range.from
      this.search.created_to = range.to
    },
    setSearch(obj) {
      this.search = Object.assign({}, obj)
      this.$emit('setSearch', this.search)
    },
    setFilters() {
      this.search.query = null
      this.search.balance = null
      this.$emit('setSearch', this.search)
    },
    setClientType(obj) {
      this.search.client_type = obj.id
    },
    setFrom(val) {
      if (!val || 0 === val.length) {
        this.search.created_from = null
        return
      }

      this.search.created_from = `${val} 00:00:00`
    },
    setTo(val) {
      if (!val || 0 === val.length) {
        this.search.created_to = null
        return
      }

      this.search.created_to = `${val} 23:59:59`
    }
  },
}
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientListForm.vue?5348b2bc